import React from 'react'

import EnhanceYourExperienceScreen from '../../screens/EnhanceYourExperienceScreen'

const EnhanceYourExperience = () => {
  return <EnhanceYourExperienceScreen />
}

export default EnhanceYourExperience
